import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { debounceTime } from "rxjs";
import { DEBOUNCE_TIME2 } from "src/app/models/consts";
import { ModuleType } from "src/app/models/enums";
import { StateService } from "src/app/services/shared/state.service";

@Component({
  selector: "app-affiliate-offers",
  templateUrl: "./affiliate-offers.component.html",
})
export class AffiliateOffersComponent implements OnInit {
  keyword: string = "";
  selectedCategoryId: number = 0;
  selectedNetworkId: number = 0;

  selectedCategoryIds: number[] = [0];
  selectedNetworkIds: number[] = [0];
  selectedCountryId: number = 0;
  selectedLanguageId: string = "";

  categoriesControlValue: any;

  inputControl: FormControl = new FormControl();

  constructor(public stateService: StateService) {}

  ngOnInit(): void {
    this.stateService.TabSelected("offers");
    this.stateService.ModuleSelected(ModuleType.Affiliate);
    this.SubscribeFormControl();
  }

  private SubscribeFormControl() {
    this.inputControl.valueChanges
      .pipe(debounceTime(DEBOUNCE_TIME2))
      .subscribe(() => {
        this.keyword = this.inputControl.value;
      });
  }

  public SelectedCategoriesChanged(selectedIds: number[]) {
    this.selectedCategoryIds = selectedIds;
  }

  public SelectedNetworksChanged(selectedIds: number[]) {
    this.selectedNetworkIds = selectedIds;
  }

  public SelectedCountryChanged(countryId: number) {
    this.selectedCountryId = countryId;
  }

  public SelectedLanguageChanged(languageId: string) {
    this.selectedLanguageId = languageId;
  }

  public RemoveNetwork(id: number) {
    if (this.selectedNetworkIds.length == 1) {
      this.selectedNetworkIds = [0];
      return;
    }
    this.selectedNetworkIds = this.selectedNetworkIds.filter((i) => i != id);
  }

  public RemoveCategory(id: number) {
    if (this.selectedCategoryIds.length == 1) {
      this.selectedCategoryIds = [0];
      return;
    }
    this.selectedCategoryIds = this.selectedCategoryIds.filter((i) => i != id);
  }

  public RemoveCountry(id: number) {
    this.selectedCountryId = 0;
  }

  public RemoveLanguage(id: string) {
    this.selectedLanguageId = "";
  }
}
